import { useMemo } from 'react';

const useHasEverAuthenticated = () => {
  return useMemo(() => {
    try {
      return localStorage.getItem('has-ever-authenticated') === 'true';
    } catch (_) {
      return false;
    }
  }, []);
};

export default useHasEverAuthenticated;


